<div class="fd-cdf-container">
    <h3 class="fd-cdf-title">{{ filterData?.filterName }}</h3>
    <div
        class="fd-cdf-filter-items-container"
        [ngClass]="{ expanded: expanded }"
    >
        <button
            *ngFor="let value of getFilterValuesToShow(); let i = index"
            class="fd-cdf-filter-item"
            [ngClass]="{ selected: value.isSelected }"
            (click)="selectionChange(i)"
        >
            {{ value.label }}
        </button>
    </div>
    <button
        mdTextButton
        *ngIf="filterData?.filterValues.length > 5"
        class="fd-cdf-expand-button"
        (click)="toggleExpand()"
    >
        <span> {{ (expanded ? "Show less" : "Show more") | translate }}</span>
        <ion-icon *ngIf="expanded" name="chevron-up-outline"></ion-icon>
        <ion-icon *ngIf="!expanded" name="chevron-down-outline"></ion-icon>
    </button>
</div>
